import { AssetMaintenanceRowsComponentBase } from './asset-maintenance-rows.component.base';
import { Component, Directive, ElementRef, Injector, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigStorage, CrudEditorParentService, CrudEditorSelfService, CrudRowsService, CrudRowsTypeInfo, UserStorage } from '@scisys-uim/uim-common';
import { ASSET_MAINTENANCE_ROWS_TYPE, AssetMaintenance } from 'assets-model';
import { AssetMaintenanceRowsService, AssetService, RefCodeStorage } from 'assets-service';

export type AssetMaintenanceRowsComponentMode = 'LIST_DOCUMENTS' | 'UPLOAD_DOCUMENTS';

@Directive()
export abstract class AssetMaintenanceRowsComponentCommon<G> extends AssetMaintenanceRowsComponentBase<G> {
  disabledColumns: string[] = [];
  parentColumns: string[] = [];
  idColumns: string[] = ['id'];

  @Input()
  showIdColumns: boolean = false;

  @Input()
  showParentColumns: boolean = false;

  constructor(protected typeInfo: CrudRowsTypeInfo<AssetMaintenance, number, G>,
    protected assetMaintenanceService: CrudRowsService<AssetMaintenance, number, G>,
    protected assetService: AssetService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected configStorage: ConfigStorage,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(typeInfo, assetMaintenanceService, assetService, refCodeStorage, fb, elementRef, router, route, configStorage, userStorage, dialog, injector, snackbar);

    this.unselectedRowsDisabled = true;
    this.clickSelectsRow = true;
    this.resetRowEnabledOnRowSelected = true;
    this.resetRowEnabledOnRowsSet = true;
    this.useCrudEntityArrayForRows = true;
  }

  ngOnInit() {
    super.ngOnInit();
    this.assetLoadSelectionList();
    this.maintenanceTypeLoadSelectionList();

    // if we disable too soon, the column header display text won't be rendered, and the picker will have code names not display names.
    this.columns.$afterViewInit.subscribe(data => {
      this.setDisplayColumnsForContext();
    });
  }

  rowsSet() {
    super.rowsSet();
  }

  private setDisplayColumnsForContext() {
    if (!this.columns) {
      return;
    }
    var disabledColumns = [...this.disabledColumns];
    if (!this.showParentColumns) {
      disabledColumns = disabledColumns.concat(this.parentColumns);
    }
    if (!this.showIdColumns) {
      disabledColumns = disabledColumns.concat(this.idColumns);
    }
    this.columns.setColumnsEnabled(disabledColumns, false);
    // reset the defaults for the context so the picker Reset button doesn't re-enable the columns above
    this.columns.resetInitialDisplayColumns();
  }

  setFormRowEnabled(row: AssetMaintenance, rowForm: FormGroup, enable: boolean) {
    if (enable) {
      rowForm.enable();

      const controls = rowForm.controls;
      for (const controlName in controls) {
        const control = controls[controlName];
        var enableControl = true;

        if (controlName == 'id') {
          enableControl = false;
        }

        this.setControlEnabled(control, enableControl);
      }
    } else {
      rowForm.disable();
    }
  }

}

@Component({
  selector: 'app-asset-maintenance-rows',
  templateUrl: './asset-maintenance-rows.component.html',
  styleUrls: ['./asset-maintenance-rows.component.scss'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class AssetMaintenanceRowsComponent extends AssetMaintenanceRowsComponentCommon<any> {

  constructor(protected assetMaintenanceService: AssetMaintenanceRowsService,
    protected assetService: AssetService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected configStorage: ConfigStorage,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(ASSET_MAINTENANCE_ROWS_TYPE, assetMaintenanceService, assetService, refCodeStorage, fb, elementRef, router, route, configStorage, userStorage, dialog, injector, snackbar);
  }
}





